import store from '@/store/index'

const splitList = (raw: string | null | undefined): string[] =>
    (raw || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)

const currentUserId = (): string => {
    const id = (store.state as any).userInfo?.details?.id
    return id != null ? String(id) : ''
}

// Which reprint dialog the current cashier gets.
//
// Driven by the `users_new_reprint_dialog` setting (store.usersNewReprintDialog):
//   ''            → nobody: every cashier uses the OLD reprint dialog (default)
//   'all'         → every cashier uses the NEW printer-status reprint dialog
//   '111,222,333' → only those cashier ids use the NEW dialog; everyone else OLD
//
// The whole new printer-status flow (dialog-driven printing, pre-purchase printer
// pre-flight, print-status reporting) is gated on this so the OLD behaviour is
// preserved verbatim for everyone not opted in.
export const isNewReprintCashier = (): boolean => {
    const raw = (store.state as any).usersNewReprintDialog
    if (typeof raw === 'string' && raw.trim().toLowerCase() === 'all') return true
    const me = currentUserId()
    if (!me) return false
    return splitList(raw).includes(me)
}
